module.exports = __webpack_public_path__ + "static/media/android.cc9d4ee1.png";